






















import { Component, Vue, Emit } from "vue-property-decorator";
import adminUserService from "../services/AdminUserService";
import authService from "../services/AuthService";

@Component
export default class Invite extends Vue {
  inviteToken: string = "";
  error: string | string[] = "";
  isComplete = false;

  created() {
    const { token, status, error } = this.$route.query;

    if (!token) {
      this.error = "Invalid token";
    } else if (error) {
      // this.error = error;
    } else {
      this.error = "";
    }

    if (this.error.length > 0) return;

    if (status === "complete") {
      this.isComplete = true;
    }

    this.inviteToken = token.toString();
  }

  handleConfirm(): void {
    if (this.inviteToken.length === 0) {
      this.error = "Invalid token";
      console.error("invalid invite token");
      return;
    }

    const token = this.inviteToken;
    adminUserService
      .confirmInvite(token)
      .then((response: any) => {
        const inviteUser = response.data;
        const now = new Date();
        const expire = new Date(inviteUser.expiryDate);
        if (expire.getTime() >= now.getTime() && inviteUser.status === "A") {
          authService.inviteAuthRequest(token);
        }
      })
      .catch((error: any) => {
        this.error = error.response.data.message;
      });
  }

  gotoLogin() {
    this.$router.push("/login");
  }
}
